module.exports = {"id":"204276","name":"Tomer Hemed","rating":"72","photo":"./data/images/photos/1/204276.png","club":{"name":"Brighton","logo":"./data/images/clubs/Brighton.png"},"positions":["BU"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/TomerHemed0.json
// module id = 4182
// module chunks = 0